import apiFetech from "../configs/axios";

export class NotificationServices {
  static getAll({ token }) {
    var config = {
      method: "get",
      url: `notifications`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    };
    return apiFetech(config);
  }
  static getByID({ token,id }) {
    var config = {
      method: "get",
      url: `notifications/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    };
    return apiFetech(config);
  }

  static setReadeByID({ token,id }) {
    var config = {
      method: "post",
      url: `reade/notifications/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    };
    return apiFetech(config);
  }

  static deleteByID({ token,id }) {
    var config = {
      method: "delete",
      url: `reade/notifications/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    };
    return apiFetech(config);
  }

}
